import { Reveal } from "./Reveal";
import NorthStar from "./NorthStar";
import { NAV_LINKS } from "../lib/data";

const SOCIALS = [
  { label: "Instagram", href: "https://instagram.com/nstrtalent" },
  { label: "TikTok", href: "https://tiktok.com" },
  { label: "LinkedIn", href: "https://linkedin.com" },
];

export default function Footer() {
  return (
    <footer className="border-t border-charcoal" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10 pt-24 sm:pt-32 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <Reveal>
              <div className="flex items-center gap-4">
                <NorthStar className="w-6 h-6 text-warm" />
                <span className="font-serif text-6xl sm:text-8xl text-warm leading-none">NSTR</span>
              </div>
              <p className="mt-8 max-w-sm text-silver font-light leading-relaxed">
                Sport. Culture. Personality. Representing the next generation of athletes,
                creators and entertainers.
              </p>
              <a
                href="mailto:talent@nstrtalent.com"
                className="mt-6 inline-block font-serif text-2xl sm:text-3xl text-warm link-underline"
                data-testid="footer-email"
              >
                talent@nstrtalent.com
              </a>
            </Reveal>
          </div>

          <div className="lg:col-span-3">
            <div className="label mb-6">Navigate</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-silver hover:text-warm transition-colors duration-500 font-light">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="label mb-6">Follow</div>
            <ul className="space-y-3">
              {SOCIALS.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    className="text-silver hover:text-warm transition-colors duration-500 font-light"
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-charcoal flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <span className="label !text-silver/60">© 2026 NSTR Talent. All rights reserved.</span>
          <a href="/admin/login" className="label !text-silver/40 hover:!text-silver transition-colors duration-500" data-testid="footer-admin">
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
